import React from 'react';
import { Col } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { AspectRatio } from '@yme/utils/constants';
export function CardSkeleton() {
    return (React.createElement(Col, { md: 4, sm: 2, lg: 4, lgMargin: "32px 0 0 0", mdMargin: "24px 0 0 0", smMargin: "24px 0 0 0" },
        React.createElement(FlexWrapper, { tabIndex: 0, flexDirection: "column" },
            React.createElement(Skeleton, { skeletonProps: {
                    width: '100%',
                    style: {
                        aspectRatio: AspectRatio.Square,
                    },
                }, withWrapper: false }),
            React.createElement(Skeleton, { skeletonProps: {
                    width: '80%',
                    height: 20,
                    style: {
                        margin: '16px 0',
                    },
                }, withWrapper: false }),
            React.createElement(Skeleton, { skeletonProps: {
                    width: 60,
                    height: 20,
                }, withWrapper: false }))));
}
